import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('handleSubmit: Appel login...');
      await login(email, password);
      console.log('handleSubmit: Login réussi, navigation vers dashboard...');
      // Attendre un peu pour s'assurer que le loading est terminé
      setTimeout(() => {
        navigate('/dashboard');
      }, 100);
    } catch (err: any) {
      console.error('handleSubmit: Erreur:', err);
      // Afficher le message d'erreur principal et les détails si disponibles
      const errorMessage = err.message || err.error || 'Erreur de connexion';
      const errorDetails = err.details || '';
      setError(errorDetails ? `${errorMessage}: ${errorDetails}` : errorMessage);
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            SOBEBRA-Zenith
          </Typography>
          <Typography component="h2" variant="h6" align="center" color="text.secondary" gutterBottom>
            Plateforme Collaborative BTL
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Adresse email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Mot de passe"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Se connecter'}
            </Button>
            <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom fontWeight="bold" align="center" color="primary">
                🔐 Comptes de Démonstration
              </Typography>
              <Box sx={{ mt: 1 }}>
                <Typography variant="caption" display="block" sx={{ mb: 1, fontWeight: 'bold' }}>
                  👑 Administrateur
                </Typography>
                <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace', mb: 1.5 }}>
                  admin@soebra.com / admin123
                </Typography>
                
                <Typography variant="caption" display="block" sx={{ mb: 1, fontWeight: 'bold', color: 'success.main' }}>
                  🏢 Agence (Concepteur de Projets)
                </Typography>
                <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace', mb: 1.5 }}>
                  agence@zenith.bj / agence123
                </Typography>
                
                <Typography variant="caption" display="block" sx={{ mb: 1, fontWeight: 'bold', color: 'warning.main' }}>
                  👑 SOBEBRA (Superviseur)
                </Typography>
                <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace', mb: 1.5 }}>
                  soebra@soebra.bj / soebra123
                </Typography>
                
                <Typography variant="caption" display="block" sx={{ mb: 1, fontWeight: 'bold', color: 'info.main' }}>
                  🧑‍💻 Agent Terrain
                </Typography>
                <Typography variant="caption" display="block" sx={{ fontFamily: 'monospace' }}>
                  agent@zenith.bj / agent123
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;

